// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gXvB","placeholdersHeader":"styles_placeholdersHeader__32Doz","editorStyle":"styles_editorStyle__1DMSf","placeholdersBox":"styles_placeholdersBox__dDNpn"};